'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

var _CloseButton = require('./CloseButton');

var _CloseButton2 = _interopRequireDefault(_CloseButton);

var _CloseButtonIcon = require('./CloseButtonIcon');

var _CloseButtonIcon2 = _interopRequireDefault(_CloseButtonIcon);

var _Text = require('./Text');

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  align-items: center;\n  background-color: ' + theme.colors.base.chrome100 + ';\n  border-radius: ' + theme.dimensions.borderRadius + ';\n  border: 1px solid ' + theme.colors.base.chrome300 + ';\n  box-sizing: border-box;\n  cursor: default;\n  display: inline-flex;\n  justify-content: space-between;\n  min-width: ' + (0, _decisivUiUtils.px2rem)(150) + ';\n  padding: 0 ' + (0, _decisivUiUtils.px2rem)(3) + ' 0 ' + (0, _decisivUiUtils.px2rem)(5) + ';\n\n  &:hover {\n    border: 1px solid ' + theme.colors.base.chrome600 + ';\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      chrome300: _propTypes2.default.string.isRequired,
      chrome600: _propTypes2.default.string.isRequired,
      chrome700: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    borderRadius: _propTypes2.default.string.isRequired
  }).isRequired
};

var Tag = (0, _decisivUiUtils.buildStyledComponent)('Tag', _styledComponents2.default.div, styles, {
  themePropTypes: themePropTypes
});

Tag.CloseButton = _CloseButton2.default;
Tag.CloseButtonIcon = _CloseButtonIcon2.default;
Tag.Text = _Text2.default;

exports.default = Tag;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/Tag/index.js
// module id = 1611
// module chunks = 2